/**
 * Utilitaire de logging qui désactive les logs en production
 * 
 * En mode production (process.env.NODE_ENV === 'production'), les logs standards sont désactivés.
 * Si REACT_APP_DISABLE_LOGS est défini à 'true', tous les logs sont désactivés, y compris les erreurs.
 */

// Détermine si l'application est en mode production
const isProduction = process.env.NODE_ENV === 'production';

// Détermine si tous les logs doivent être désactivés (utilisé pour la version mainnet)
const disableAllLogs = process.env.REACT_APP_DISABLE_LOGS === 'true';

// Crée un objet logger qui remplace les fonctions de console standard
const logger = {
  log: (...args) => {
    if (!isProduction && !disableAllLogs) {
      console.log(...args);
    }
  },
  
  error: (...args) => {
    // En mode mainnet (disableAllLogs), même les erreurs sont désactivées
    // En mode production normal, nous gardons les erreurs pour le débogage
    if (!disableAllLogs) {
      console.error(...args);
    }
  },
  
  warn: (...args) => {
    if (!isProduction && !disableAllLogs) {
      console.warn(...args);
    }
  },
  
  info: (...args) => {
    if (!isProduction && !disableAllLogs) {
      console.info(...args);
    }
  },
  
  debug: (...args) => {
    if (!isProduction && !disableAllLogs) {
      console.debug(...args);
    }
  },
  
  // Fonction spéciale pour les logs critiques qui doivent toujours être affichés
  // Même en mode mainnet, nous affichons les erreurs critiques
  critical: (...args) => {
    if (!disableAllLogs) {
      console.error('[CRITICAL]', ...args);
    }
  }
};

export default logger;
